export default {
  validation: {
    required: '필수 항목입니다',
    kana_format: '전각 가타가나 (으)로 입력해 주세요.',
    email_format: '@.lower:validation.variables.email 이/가 부정확합니다',
    date_format: '@.lower:validation.variables.date 을/를 입력해 주세요',
    number_format: '@.lower:validation.variables.number 을/를 입력해 주세요',
    halfwidth_number_format: '반각 숫자만으로 입력해 주세요.',
    alphanumeric_format: '@.lower:validation.variables.alphanumeric (으)로 입력해 주세요.',
    postal_number_no_hyphen: '@.lower:validation.variables.postal_number (으)로 입력해 주세요.',
    postal_number_format: '@:validation.variables.postal_number 을/를 입력해 주세요',
    login_email_required: '@:validation.required',
    login_email_format: '@:validation.email_format',
    login_password_required: '@:validation.required',
    // login_password_format: "",
    // min_length: "",
    // max_length: "",
    // greater_than_or_equal_number: "",
    // greater_than_number: "",
    // less_than_or_equal_number: "",
    // less_than_number: "",
    max_digit: '{digit} 자리 이내로 입력해 주세요.',
    max_digit_with_item: '{item} (이)가 {digit} 자리 이하가 되도록 입력해 주세요.',
    // number_only: "",
    // decimal_max_digit: "",
    no_blank_or_newline: '공백이나 줄바꿈만 입력할 수는 없습니다',
    // invalid_zero_number: "",
    variables: {
      id_or_email: 'ID/이메일 주소',
      email: '이메일 주소',
      password: '패스워드',
      kana: '',
      date: '일자(예: 31/01/2023)',
      number: '값',
      alphanumeric: '반각 영문/숫자',
      postal_number: '우편번호',
    },
  },
}
